import Skeleton from '@material-ui/lab/Skeleton/Skeleton'
import React, { FC } from 'react'

interface ISkeletonProps {
    height?: number
}
export const LoadingSkeleton: FC<ISkeletonProps> = React.memo(({ height }) => {
    const computedHeight = height ?? 12
    return (
        <Skeleton
            variant="rect"
            animation="wave"
            width="80%"
            style={{
                borderRadius: '2px',
                height: `${computedHeight}px`,
                gap: '2px',
            }}
        />
    )
})
